module.exports = __webpack_public_path__ + "static/media/34DSS2.5f8f9731.jpg";